import * as React from 'react';
import Svg, {
  SvgProps, Path, G, Defs, ClipPath, Rect,
} from 'react-native-svg';

const ChartBarIcon = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <G clipPath='url(#clip0_1603_94664)'>
    <Path
      d='M3 13V8.5H6'
      stroke='#3379BD'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M14 13H2'
      stroke='#3379BD'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M6 13V5.5H9.5'
      stroke='#3379BD'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M9.5 13V2.5H13V13'
      stroke='#3379BD'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </G>
  <Defs>
    <ClipPath id='clip0_1603_94664'>
      <Rect
        width='16'
        height='16'
        fill='white'
      />
    </ClipPath>
  </Defs>
</Svg>;

export default ChartBarIcon;
